import React, { useState } from 'react';
import { RotateCcw } from 'lucide-react';
import { toast } from 'sonner';
import { jsonApi } from '@/lib/jsonApi';
import { Button } from '@/components/ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

const fmt = (iso) => { try { return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); } catch { return ''; } };

export function SetupOrigin({ setup }) {
  if (!setup) return null;
  const text = {
    template: `Started from the ${setup.template_name} template`,
    empty: 'Started from an empty list',
    legacy_starter: 'Started from the earlier generic starter list',
  }[setup.status];
  if (!text) return null;
  return <p className="text-xs text-[#94A3B8]" data-testid="taxonomy-setup-origin">{text}{setup.applied_at ? ` · ${fmt(setup.applied_at)}` : ''} · this client’s own copy</p>;
}

// satisFIND-admin only; backend refuses once any response has been tagged.
export function ResetTaxonomy({ onDone }) {
  const [open, setOpen] = useState(false);
  const reset = async () => {
    try { await jsonApi('/taxonomy/reset', 'POST'); toast.success('Attributes & Factors reset — choose a new starting point'); onDone(); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <section className="border border-[#F0C6C9] bg-[#FFF8F8] rounded-2xl p-5 flex flex-col md:flex-row md:items-center justify-between gap-3" data-testid="taxonomy-reset-card">
      <div>
        <p className="text-sm font-bold text-[#7F1D1D]">Reset this client’s Attributes &amp; Factors</p>
        <p className="text-xs text-[#9F1239] mt-0.5">satisFIND admins only. Allowed only while no response has been tagged. Removes this client’s list so a new starting point can be chosen.</p>
      </div>
      <Button variant="outline" onClick={() => setOpen(true)} className="border-[#E8A5AA] text-[#A1272E] hover:bg-[#FFF0F0] shrink-0" data-testid="taxonomy-reset-btn"><RotateCcw className="w-4 h-4 mr-1.5" /> Reset</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="taxonomy-reset-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Reset Attributes &amp; Factors?</AlertDialogTitle>
            <AlertDialogDescription>This deletes this client’s current list and its survey factor settings. Master templates and other clients are not affected.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="taxonomy-reset-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={reset} className="bg-[#A1272E] hover:bg-[#861F25]" data-testid="taxonomy-reset-confirm">Reset</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}
